"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactstrap = require("reactstrap");

var LoginOrLogout = function LoginOrLogout(_ref) {
  var logout = _ref.logout,
      openLoginModal = _ref.openLoginModal,
      openSignUpModal = _ref.openSignUpModal,
      isLoggedIn = _ref.isLoggedIn;
  return _react["default"].createElement("div", null, isLoggedIn ? _react["default"].createElement(_reactstrap.DropdownItem, {
    onClick: function onClick() {
      return logout();
    }
  }, " Log out") : _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_reactstrap.DropdownItem, {
    onClick: function onClick() {
      return openLoginModal();
    }
  }, "Log in"), _react["default"].createElement(_reactstrap.DropdownItem, {
    onClick: function onClick() {
      return openSignUpModal();
    }
  }, "Sign up")));
};

var _default = LoginOrLogout;
exports["default"] = _default;